import { Component, OnInit } from '@angular/core';
import {SharedService} from '../shared-service.service';

@Component({
  selector: 'app-quote-detail',
  templateUrl: './quote-detail.component.html',
  styleUrls: ['./quote-detail.component.css']
})
export class QuoteDetailComponent implements OnInit {

  constructor(public shared: SharedService) { }

  ngOnInit() {
  }

}
